import React from "react";
import { GatsbyBrowser } from "gatsby";
import type Rollbar from "rollbar";
import { RollbarInstanceProvider } from "./RollbarProvider";
import { installEarlyCapture, scheduleRollbarLoad } from "./lazyRollbar";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element
}) => {
  return <RollbarInstanceProvider>{element}</RollbarInstanceProvider>;
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = (
  _,
  pluginOptions
) => {
  // Capture errors (including outside React) from time zero via a tiny queue;
  // the SDK itself loads on idle — or immediately on the first error — and
  // flushes the queue. It also exposes window.Rollbar for external libraries
  // (ie analytics), which therefore becomes available only after that load.
  installEarlyCapture();
  scheduleRollbarLoad(pluginOptions as unknown as Rollbar.Configuration);
};
